import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isTitle',
    standalone: true,
})
export class IsTitlePipe implements PipeTransform {
    transform(value: string, ...args: unknown[]): boolean {
        return value?.indexOf('title-main') > -1;
    }
}
